/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 6.5L10.8686 3.97528C9.2771 3.00267 8.48133 2.51637 7.82571 2.57372C7.25412 2.62372 6.73153 2.91681 6.39081 3.37846C6 3.90799 6 4.84059 6 6.70578V12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 12V17.2942C6 19.1594 6 20.092 6.39081 20.6215C6.73153 21.0832 7.25412 21.3763 7.82571 21.4263C8.48133 21.4836 9.2771 20.9973 10.8686 20.0247L19.5319 14.7305C21.0092 13.8277 21.7478 13.3763 21.9997 12.7952C22.2195 12.2879 22.2195 11.7121 21.9997 11.2048C21.7478 10.6237 21.0092 10.1723 19.5319 9.2695L15 6.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M6 17.2942V6.70578C6 4.84059 6 3.90799 6.39081 3.37846C6.73153 2.91681 7.25412 2.62372 7.82571 2.57372C8.48133 2.51637 9.2771 3.00267 10.8686 3.97528L19.5319 9.2695C21.0092 10.1723 21.7478 10.6237 21.9997 11.2048C22.2195 11.7121 22.2195 12.2879 21.9997 12.7952C21.7478 13.3763 21.0092 13.8277 19.5319 14.7305L10.8686 20.0247C9.2771 20.9973 8.48133 21.4836 7.82571 21.4263C7.25412 21.3763 6.73153 21.0832 6.39081 20.6215C6 20.092 6 19.1594 6 17.2942Z"
				fill="currentColor"
			/>
			<path
				d="M6 17.2942V6.70578C6 4.84059 6 3.90799 6.39081 3.37846C6.73153 2.91681 7.25412 2.62372 7.82571 2.57372C8.48133 2.51637 9.2771 3.00267 10.8686 3.97528L19.5319 9.2695C21.0092 10.1723 21.7478 10.6237 21.9997 11.2048C22.2195 11.7121 22.2195 12.2879 21.9997 12.7952C21.7478 13.3763 21.0092 13.8277 19.5319 14.7305L10.8686 20.0247C9.2771 20.9973 8.48133 21.4836 7.82571 21.4263C7.25412 21.3763 6.73153 21.0832 6.39081 20.6215C6 20.092 6 19.1594 6 17.2942Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.1186 2.63788C8.5271 1.66527 7.73133 1.17897 7.07571 1.23632C6.50412 1.28632 5.98153 1.57941 5.64081 2.04106C5.25 2.57059 5.25 3.50319 5.25 5.36838V18.6314C5.25 20.4966 5.25 21.4292 5.64081 21.9587C5.98153 22.4204 6.50412 22.7135 7.07571 22.7635C7.73133 22.8208 8.5271 22.3345 10.1186 21.3619L20.9702 14.7304C22.4475 13.8276 23.1861 13.3762 23.438 12.7951C23.6578 12.2877 23.6578 11.712 23.438 11.2047C23.1861 10.6236 22.4475 10.1722 20.9702 9.26939L10.1186 2.63788Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M13 5.27775L10.8686 3.97526C9.2771 3.00265 8.48133 2.51635 7.82571 2.5737C7.25412 2.6237 6.73153 2.91679 6.39081 3.37844C6 3.90797 6 4.84056 6 6.70576V7.99982M6 11.9998V17.2942C6 19.1594 6 20.092 6.39081 20.6215C6.73153 21.0832 7.25412 21.3763 7.82571 21.4263C8.48133 21.4836 9.2771 20.9973 10.8686 20.0247L19.5319 14.7305C21.0092 13.8277 21.7478 13.3763 21.9997 12.7952C22.2195 12.2878 22.2195 11.7121 21.9997 11.2048C21.7478 10.6237 21.0092 10.1723 19.5319 9.26947L16 7.11109"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 17.2942V6.70578C6 4.84059 6 3.90799 6.39081 3.37846C6.73153 2.91681 7.25412 2.62372 7.82571 2.57372C8.48133 2.51637 9.2771 3.00267 10.8686 3.97528L19.5319 9.2695C21.0092 10.1723 21.7478 10.6237 21.9997 11.2048C22.2195 11.7121 22.2195 12.2879 21.9997 12.7952C21.7478 13.3763 21.0092 13.8277 19.5319 14.7305L10.8686 20.0247C9.2771 20.9973 8.48133 21.4836 7.82571 21.4263C7.25412 21.3763 6.73153 21.0832 6.39081 20.6215C6 20.092 6 19.1594 6 17.2942Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.1186 2.638C8.5271 1.66539 7.73133 1.17909 7.07571 1.23644C6.50412 1.28644 5.98153 1.57953 5.64081 2.04118C5.25 2.57071 5.25 3.50331 5.25 5.36851V18.6315C5.25 20.4967 5.25 21.4293 5.64081 21.9588C5.98153 22.4205 6.50412 22.7136 7.07571 22.7636C7.73133 22.8209 8.5271 22.3346 10.1186 21.362L20.9702 14.7305C22.4475 13.8277 23.1861 13.3763 23.438 12.7952C23.6578 12.2879 23.6578 11.7122 23.438 11.2048C23.1861 10.6237 22.4475 10.1723 20.9702 9.26951L10.1186 2.638Z"
				fill="currentColor"
			/>
			<path
				d="M5.25 12V5.36838C5.25 3.50318 5.25 2.57059 5.64081 2.04106C5.98153 1.57941 6.50412 1.28632 7.07571 1.23632C7.73133 1.17897 8.5271 1.66527 10.1186 2.63788L20.9702 9.26939C22.4475 10.1722 23.1861 10.6236 23.438 11.2047C23.5479 11.4584 23.6029 11.7292 23.6028 12H5.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
